module.exports = __webpack_public_path__ + "media/images/partners/samsung-869375b82e1fc4537770c5de8c514e11.png";